import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  title,
  domain1Color,
  domain2Color,
  domain3Color,
  domain4Color,
  domain5Color,
  domain6Color,
  domain7Color
} from "assets/jss/material-kit-pro-react.jsx";

const answerAreaStyle = {
  infoDomainArea: {
    maxWidth: "360px",
    margin: "0 auto",
    padding: "0px"
  },
  image: {
    maxWidth: "100px"
  },
  iconWrapper: {
    float: "left",
    marginTop: "24px",
    marginRight: "10px"
  },
  stepperRadio: {
    padding: "2px"
  },
  D1: {
    color: domain1Color[0],
    fontSize: "2em",
    "&$disabled": {
      color: "green"
    }
  },
  D2: {
    color: domain2Color[0],
    fontSize: "2em",
    "&$disabled": {
      color: "green"
    }
  },
  D3: {
    color: domain3Color[0]
  },
  D4: {
    color: domain4Color[0]
  },
  D5: {
    color: domain5Color[0]
  },
  D6: {
    color: domain6Color[0]
  },
  D7: {
    color: domain7Color[0]
  },
  design: {
    color: "#fbc108"
  },
  facilitate: {
    color: "#e65100"
  },
  optimise: {
    color: "#259688"
  },
  assessment: {
    color: "#2c9be5"
  },
  experience: {
    color: "#9abfcf"
  },
  industry: {
    color: "#cf26b6"
  },
  innovation: {
    color: "#6739b7"
  },
  warning: {
    color: warningColor
  },
  danger: {
    color: dangerColor
  },
  success: {
    color: successColor
  },
  info: {
    color: infoColor
  },
  rose: {
    color: roseColor
  },
  gray: {
    color: grayColor
  },
  icon: {
    width: "36px",
    height: "36px"
  },
  descriptionWrapper: {
    color: grayColor,
    overflow: "hidden"
  },
  title,
  description: {
    color: grayColor,
    overflow: "hidden",
    marginTop: "0px",
    fontSize: "14px"
  },
  iconWrapperVertical: {
    float: "none"
  },
  iconVertical: {
    width: "61px",
    height: "61px"
  }
};

export default answerAreaStyle;
